import React, { useState } from 'react';
import DropDown from './DropDown';
import AddToFotaCampaign from './AddToFotaCampaign';
import AddToDtFotaCampaign from './AddToDtFotaCampaign';
import { AddToFotaCampaignProps } from '../../types/AddToFotaCampaignProps';

type FotaCampaignDropdownProps = AddToFotaCampaignProps & {
  pickerClassName?: string;
};

function FotaCampaignDropdown({
  selectedItems,
  closeDropdown,
  pickerClassName = '',
}: FotaCampaignDropdownProps): JSX.Element {
  const [fotaSubMode, setFotaSubMode] = useState(0); // 0=picker, 1=fota, 2=dtfota

  return (
    <>
      {fotaSubMode === 0 && (
        <div className={pickerClassName}>
          <DropDown>
            <>
              <button
                type="button"
                className="actions-commission__element"
                onClick={() => setFotaSubMode(1)}
              >
                Add to FOTA campaign
              </button>
              <button
                type="button"
                className="actions-commission__element"
                onClick={() => setFotaSubMode(2)}
              >
                Add to DTFOTA campaign
              </button>
            </>
          </DropDown>
        </div>
      )}
      {fotaSubMode === 1 && (
        <AddToFotaCampaign
          selectedItems={selectedItems}
          closeDropdown={() => { setFotaSubMode(0); closeDropdown(); }}
        />
      )}
      {fotaSubMode === 2 && (
        <AddToDtFotaCampaign
          selectedItems={selectedItems}
          closeDropdown={() => { setFotaSubMode(0); closeDropdown(); }}
        />
      )}
    </>
  );
}

FotaCampaignDropdown.defaultProps = {
  pickerClassName: '',
};

export default FotaCampaignDropdown;
